import Search from "./Search";
export default function Team(){
    return(
        <>
        <section className="theTeam">
            <Search/>
            <div className="abtTeam">
                <h3>Meet the Team</h3>
                <p>
                Welcome to BuyVal where we make you a seller and find you a buyer. Behind every seamless transaction and delightful shopping experience there is a group of individual committed to making your journey extraordinary. Get to know the faces behind the scenes:
                </p>
            </div>
            <div className="team_members">
                <div className="image">
                    <img src="/L-page_assets/group_83.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/grp_84.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/grp_85.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/group_83.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/grp_84.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/grp_85.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/group_83.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/grp_84.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
                <div className="image">
                    <img src="/L-page_assets/grp_85.png" alt="" />
                    <div className="foot">
                        <p className="name">Hackie Clement</p>
                        <p className="pos">CEO Buyval Nigeria</p>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}